import React, { useState } from "react";
import axios from "axios";
import {
  Grid,
  Typography,
  FormGroup,
  Card,
  CardContent,
  TextField,
  Button,
} from "@material-ui/core";
function ReportingModeCartHandle(props) {
  const [topologyName, setTopologyName] = useState("");
  const [topologyDescription, setTopologyDescription] = useState("");
  const handleCreateTopology = async () => {
    const arr = props.cartItems.map((item) => item.scenario_uuid);
    const payload = {
      cad_tag_name: topologyName,
      cad_description: topologyDescription,
      model_version: props.selectValue,
      ...(props.type === "pg") && {fctw_scenario: props.fctw},
      selected_scenarios: arr,
    };
    try {
      await axios.post(
        props.type === "pg"
          ? "/cm/reporting-mode/cad-creation"
          : "/cm/reporting-mode/pr-cad-creation",
        payload
      );
      props.handleClose(true);
    } catch (err) {
      console.error("err", err);
    }
  };
  return (
    <div>
      <Grid
        container
        spacing={1}
        style={{
          fontWeight: 400,
          fontSize: "16px",
          backgroundColor: "white",
          border: "solid 1px rgba(0,0,0,.2)",
          borderRadius: "10px",
          padding: "10px",
          marginTop: "0.5rem",
          height: "450px",
        }}
      >
        <Grid item sm={6}>
          <Typography variant="h5" style={{ flexGrow: 1 }}>
            Topology Creation
          </Typography>
        </Grid>
        <Grid item sm={6} style={{ display: "flex", justifyContent: "end" }}>
          <Button
            onClick={() => props.clearCart()}
            variant="outlined"
            color="secondary"
            disabled={props.cartItems.length === 0}
            style={{ height: "40px", marginRight: "1rem" }}
          >
            Clear Cart
          </Button>
          <Button
            onClick={() => props.handleClose()}
            variant="outlined"
            color="secondary"
            style={{ height: "40px" }}
          >
            Close
          </Button>
        </Grid>
        <Grid item sm={6}>
          <div style={{ height: "250px", overflowY: "auto" }}>
            Selected <b>{props.cartItems.length}</b> in the Topology
            {props.cartItems.slice(0, 10).map((item, index) => (
              <div
                key={item.scenario_uuid}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <Typography variant="body2" style={{ flexGrow: 1 }}>
                  {item.scenario_name}
                </Typography>
                {index === 9 && props.cartItems.length > 10 && (
                  <div>
                    <Typography>{`and ${
                      props.cartItems.length - 10
                    } more`}</Typography>
                  </div>
                )}
              </div>
            ))}
          </div>
        </Grid>
        <Grid item sm={6}>
          {props.cartItems.length > 0 && (
            <Card>
              <CardContent>
                {/* <FormControl
                  variant="outlined"
                  style={{ width: "100%", marginBottom: "10px" }}
                >
                  <Select
                    value={selectModalValue}
                    // onChange={handleSelectChange}
                    readOnly
                  >
                    {modelOptions.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl> */}
                <FormGroup>
                  <Typography variant="h6">
                    Selected Model: {props.selectValue}
                  </Typography>
                  <TextField
                    required
                    id="topo-name"
                    label="Topology Name"
                    value={topologyName}
                    onChange={(e) => setTopologyName(e.target.value)}
                    fullWidth
                    margin="normal"
                  />
                  <TextField
                    required
                    id="topo-description"
                    label="Description"
                    value={topologyDescription}
                    onChange={(e) => setTopologyDescription(e.target.value)}
                    fullWidth
                    margin="normal"
                  />
                </FormGroup>
                <div style={{ position: "relative" }}>
                  <Button
                    variant="contained"
                    disabled={!topologyName.trim() || !topologyDescription.trim()}
                    fullWidth
                    style={{
                      marginTop: "10px",
                      backgroundColor:
                        !topologyName.trim() || !topologyDescription.trim()
                          ? "#e0e0e0"
                          : "#622ad8",
                      color: "white",
                    }}
                    onClick={handleCreateTopology}
                  >
                    Create Topology
                  </Button>
                </div>
              </CardContent>
            </Card>
          )}
        </Grid>
      </Grid>
    </div>
  );
}

export default ReportingModeCartHandle;
